
define('text!modules/T1App/edit/access/users/templates/userSearch.html',[],function () { return '<strand-input class="search-input search-team-users" placeholder="Search" search clear></strand-input>';});

